import type { EntityType } from './EntityNotesPanel';

/**
 * Options for the Notes timeline "Entity" filter, shared by the dashboard-wide
 * and asset-scoped Notes tabs.
 *
 * `Device` covers gateways (the backend dropped the dedicated `Gateway` type).
 * The asset dashboard renders `Endpoint` (not `Point`) for lubrication points.
 */
export const ENTITY_TYPE_OPTIONS: { value: EntityType; text: string }[] = [
  { value: 'Asset', text: 'Asset' },
  { value: 'Endpoint', text: 'Endpoint' },
  { value: 'Device', text: 'Gateway' },
  { value: 'GreasePump', text: 'Grease Pump' },
  { value: 'Alert', text: 'Alert' },
  { value: 'AlertNotification', text: 'Alert Notification' },
];
